

setTimeout(() => {
  const toolbar = document.querySelector(".boost-sd__toolbar-container");

  if (!toolbar) return; // safety check

  window.addEventListener("scroll", function () {
    const rect = toolbar.getBoundingClientRect();

    if (rect.top === 0) {
      toolbar.classList.add("active");
    } else {
      toolbar.classList.remove("active");
    }
  });
}, 3000); // 3 seconds delay


window.addEventListener("load",(event)=>{setTimeout(()=>{document.querySelector(".tab-button.active").click()},"1000");const openPopupButton=document.getElementById('openPopup');const popup=document.getElementById('popup');const closePopupButton=document.getElementById('closePopup');const body=document.querySelector('body');openPopupButton.addEventListener('click',()=>{popup.style.display='flex';body.classList.add("active_body")});closePopupButton.addEventListener('click',()=>{popup.style.display='none';body.classList.remove("active_body")});popup.addEventListener('click',(event)=>{if(event.target===popup){popup.style.display='none';body.classList.remove("active_body")}})})







 